import * as types from './types';

export const updateBase = (persistedState) => ({
  type: types.UPDATE,
  persistedState,
});

export const setSelectedMetrics = (metrics) => ({
  type: types.SET_SELECTED_METRICS,
  metrics,
});

export const setSelectedDimension = (dimension) => ({
  type: types.SET_SELECTED_DIMENSION,
  dimension,
});

export const setAppliedSort = (sort) => ({
  type: types.SET_APPLIED_SORT,
  sort,
});

// eslint-disable-next-line max-len
export const setDefaultFilterInterval = (
  filter,
  interval,
  color,
  granularity,
  shortcut,
  index,
) => ({
  type: types.SET_DEFAULT_FILTER_INTERVAL,
  filter,
  interval,
  color,
  granularity,
  shortcut,
  index,
});

export const setAppliedFilters = (filter, index) => ({
  type: types.SET_SELECTED_FILTERS,
  filter,
  index,
});

export const setAppliedInterval = (interval, index) => ({
  type: types.SET_SELECTED_INTERVAL,
  interval,
  index,
});

export const setAppliedShortcut = (shortcut, index) => ({
  type: types.SET_SELECTED_SHORTCUT,
  shortcut,
  index,
});

export const setAppliedGranularity = (granularity, index) => ({
  type: types.SET_SELECTED_GRANULARITY,
  granularity,
  index,
});

export const setLiveMode = (mode) => ({
  type: types.SET_LIVE_MODE,
  mode,
});

export const removeAppliedFilter = (index) => ({
  type: types.REMOVE_APPLIED_FILTER,
  index,
});

export const updateUnit = (unit) => ({
  type: types.SET_UNIT_MODE,
  unit,
});

export const persistState = (configuration) => ({
  type: types.PERSIST_STATE,
  configuration,
});

export const setAppliedSearch = (search) => ({
  type: types.SET_APPLIED_SEARCH,
  search,
});
